// The `?new=<path>` hand-off from the repo-browser dialog.
//
// The dialog validates the SHAPE of a typed path (no `..`, no empty segment, a
// known extension) but has no directory listing, so it cannot know whether the
// path is free. The workspace can refuse it — the name may already be a
// directory, or live under a file — and it refuses SILENTLY, by design, because
// the nav's inline editor reports refusals itself.
//
// Nothing reported it here: the route created, then navigated to the file
// regardless, landing the user on a route for a document that does not exist,
// with the `?new=` param already stripped so there was nothing to retry.

import type { WorkspaceStore } from "@archlang/app-shell/workbench";
import { newFileSeed } from "@archlang/viewer-core/workspace-file";

export type CreateOutcome = "created" | "exists" | "refused";

/**
 * Create the file `?new=` asked for, seeded if it is a manifest.
 * `exists` means the path was already there — the file is opened, not clobbered.
 */
export function createRequestedFile(
  store: WorkspaceStore,
  files: ReadonlyMap<string, string>,
  wanted: string,
): CreateOutcome {
  if (files.has(wanted)) return "exists";
  store.createFile(wanted, newFileSeed(wanted, files.keys()));
  return store.getState().files.has(wanted) ? "created" : "refused";
}
